module.exports = __webpack_public_path__ + "ff95a4d13e36ad6ac35f2d268c8fa4fd.png";